import { useUserStore } from '@/stores/user';
import type { StorageLike } from 'pinia-plugin-persistedstate';

export function getPersistScope(): string {
    return String(useUserStore().id);
}

export function getStorePersistKey(pageId: string): string {
    return `${pageId}:store:${getPersistScope()}`;
}

export function getFiltersPersistKey(pageId: string): string {
    return `${pageId}:filters:${getPersistScope()}`;
}

export function getMenuRecentPersistKey(): string {
    return `menu:recent:${getPersistScope()}`;
}

export function getInputHistoryPersistKey(): string {
    return `input-history:${getPersistScope()}`;
}

export function createScopedPersistStorage(getKey: () => string): StorageLike {
    return {
        getItem(_key: string) {
            if (useUserStore().id == null) {
                return null;
            }

            return localStorage.getItem(getKey());
        },
        setItem(_key: string, value: string) {
            if (useUserStore().id == null) {
                return;
            }

            localStorage.setItem(getKey(), value);
        },
    };
}

type PersistPanelStore = {
    hiddenFilters?: string[];
    filterOrder?: string[];
    hiddenColumns?: string[];
    availableFilters?: { key: string }[];
    availableColumns?: { key?: string | number }[];
};

export function sanitizePagePersistState(store: PersistPanelStore): void {
    const filterKeys = new Set(store.availableFilters?.map((filter) => filter.key) ?? []);

    if (Array.isArray(store.hiddenFilters)) {
        store.hiddenFilters = store.hiddenFilters.filter((key) => filterKeys.has(key));
    }

    if (Array.isArray(store.filterOrder)) {
        store.filterOrder = store.filterOrder.filter((key) => filterKeys.has(key));
    }

    const columnKeys = new Set(
        store.availableColumns?.map((column) => column.key).filter((key): key is string => typeof key === 'string' && key.length > 0) ?? []
    );

    if (Array.isArray(store.hiddenColumns) && columnKeys.size > 0) {
        store.hiddenColumns = store.hiddenColumns.filter((key) => columnKeys.has(key));
    }
}
